import { render, staticRenderFns } from "./Socios.vue?vue&type=template&id=462dacde&scoped=true&"
import script from "./Socios.vue?vue&type=script&lang=js&"
export * from "./Socios.vue?vue&type=script&lang=js&"
import style0 from "./Socios.vue?vue&type=style&index=0&id=462dacde&prod&lang=css&"
import style1 from "./Socios.vue?vue&type=style&index=1&id=462dacde&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462dacde",
  null
  
)

export default component.exports